import { styled } from '@material-ui/core';
import { SButton, SRoundedContainer } from '@setvi/shared/components';
import { IntelligenceColorMap } from 'pages/sales/modules/intelligence/config';
import { PlusIcon, RightArrowIcon } from '@setvi/shared/components/sicons';

export const ControlPanelWrapper = styled(SRoundedContainer)(({ theme }) => ({
  padding: '30px 24px',
  marginTop: '4px',
  backgroundColor: IntelligenceColorMap.BackgroundSubtle,
  position: 'fixed',
  width: '100%',
  zIndex: theme.zIndex.modal,
  left: 0,
  bottom: 0,
  borderBottom: 'none',
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const SideWrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '16px'
});

export const SelectedBadgeButton = styled(SButton)({
  borderColor: IntelligenceColorMap.BorderPrimary,
  borderRadius: '120px',
  padding: '8px 12px',
  fontWeight: 400,
  color: IntelligenceColorMap.TextTertiary,
  '&:hover': {
    backgroundColor: IntelligenceColorMap.BackgroundPressedHover
  }
});

export const CancelButton = styled(SButton)({
  borderRadius: '999px'
});

export const AddButton = styled(SButton)({
  borderRadius: '999px'
});

export const RightIcon = styled(RightArrowIcon)({
  width: '10px',
  height: '10px'
});

export const PlusButtonIcon = styled(PlusIcon)({
  width: '14px',
  height: '14px'
});
